<div class="fui-embed" [class.destination-fender]="destination === 'fender.com'" [class.destination-play]="destination === 'play.fender.com'">
  @if (loading) {
    <div class="fui-embed__state">
      <div class="fui-embed__spinner"></div>
    </div>
  } @else if (isHappeningNow && playerVideo) {
    <!-- Live: inline player (comments/shop/sign-up panel, not a modal) fills the iframe -->
    <myp-video-player
      [embedMode]="true"
      [initialVideo]="playerVideo"
      [commentsEnabled]="commentsEnabled"
      [shopEnabled]="shopEnabledResolved"
      [signupEnabled]="signupEnabledResolved"
      [signupConfig]="signupConfigResolved?.livestream"
      [signupEventId]="event?.id"
    ></myp-video-player>
  } @else if (event) {
    <!-- Pre-show: shared countdown UI (also used by the in-app video player). The sign-up CTA opens
         the in-embed sign-up form (DENG-892); only shown when sign-up is enabled for the event. -->
    <fui-livestream-countdown
      [event]="event"
      [signupEnabled]="signupEnabledResolved"
      [signupConfig]="signupConfigResolved?.countdown"
      [signupEventId]="event?.id"
      [previewVideoId]="previewVideoId"
      (wentLive)="onWentLive()"
    ></fui-livestream-countdown>
  } @else {
    <div class="fui-embed__state">
      <div class="fui-embed__content">
        <div class="fui-embed__label">No upcoming livestreams</div>
        <p class="fui-embed__subtle">Check back soon for the next event.</p>
      </div>
    </div>
  }
</div>
